import { List as MuiList, type ListProps as MuiListProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props = WithoutStyleOverrides<MuiListProps> & {
  maxHeight?: number;
};

export function List(props: Props) {
  const { maxHeight, ...listProps } = props;

  return <MuiList {...listProps} sx={maxHeight === undefined ? undefined : { maxHeight, overflowY: 'auto' }} />;
}

export type { Props as ListProps };
